import { t } from "i18next";

export const getStatusColor = (status: string) => {
    switch (status) {
        case 'ACTIVE':
            return 'success';
        case 'PENDING':
            return 'warning';
        case 'SUSPENDED':
            return 'danger';
        case 'DEACTIVATED':
            return 'default';
        default:
            return 'default';
    }
};


export const formatManagerType = (type: string) => {
    return type === 'INDIVIDUAL' ? t('yes') : type === 'AGENCY' ? t('no') : type;
};

export const formatSelectOption = (option: string) => {
    if (option.startsWith(t('all_types'))) return option;
    return option === 'INDIVIDUAL' ? t('yes') : option === 'AGENCY' ? t('no') : option;
};